/**
 * On-screen numeric keypad (docs/06-UI-SPEC.md §4).
 *
 * Shown on touch devices, where the system keyboard is unreliable, slow to appear and
 * often covers the very boxes the student is filling in. Keys are well over the
 * 44 px minimum touch target from docs/07-DESIGN-SYSTEM.md §9.
 */

const KEYS = ['1', '2', '3', '4', '5', '6', '7', '8', '9'] as const;

export interface NumericKeypadProps {
  readonly onDigit: (digit: string) => void;
  readonly onBackspace: () => void;
}

const KEY_CLASS =
  'flex h-16 items-center justify-center rounded-md border border-border bg-surface text-2xl font-semibold text-text-primary transition duration-instant ease-out active:bg-surface-hover';

export function NumericKeypad({ onDigit, onBackspace }: NumericKeypadProps) {
  return (
    <div className="grid w-full max-w-[320px] grid-cols-3 gap-3">
      {KEYS.map((key) => (
        <button
          key={key}
          type="button"
          className={KEY_CLASS}
          onClick={() => {
            onDigit(key);
          }}
        >
          {key}
        </button>
      ))}
      <span />
      <button
        type="button"
        className={KEY_CLASS}
        onClick={() => {
          onDigit('0');
        }}
      >
        0
      </button>
      <button type="button" aria-label="Delete" className={KEY_CLASS} onClick={onBackspace}>
        ⌫
      </button>
    </div>
  );
}
